import type { Footer } from '@/types/contentstack';
import { sanitizeHtml } from '@utils/sanitizer';

const ID_PREFIX = 'social-link-footer';
const LOGO_URL =
  'https://www.itau.com.br/media/dam/m/6a808d85be1e3922/original/logo-social-link-itau-footer.svg';

export type FooterParams = Footer;

export function renderFooter(infos: FooterParams): string {
  const year = new Date().getFullYear();

  return `
  <footer class="main-footer" data-testid="${ID_PREFIX}">
    <div class="main-footer__legal-info" data-testid="${ID_PREFIX}-legal-info">
      <div class="ids-container ids-p-4">
        <div class="ids-pt-4 ids-pb-2 infos" data-testid="${ID_PREFIX}-infos">
          <div>
            <img src="${LOGO_URL}" alt="Logo Social Link" data-testid="${ID_PREFIX}-image" />
          </div>
          <div>
            <span class="infos__legal ids-body-text-variant" data-testid="${ID_PREFIX}-infos-legal">&copy; ${year} ${sanitizeHtml(infos.legal_infos)}</span>
            <address data-testid="${ID_PREFIX}-address">${sanitizeHtml(infos.address)}</address>
          </div>
        </div>
      </div>
    </div>
  </footer>`;
}
